import type { FC } from "react";

import { Alert, Icon } from "@alpacahq/ui/old";

export const InternationalWireNotes: FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <Alert
      variant="info"
      className={className}
      message={
        <span className="flex gap-4">
          <Icon name="InformationCircle" />
          Funds have to be received and sent in USD. We do not convert funds or
          reimburse for any conversion that may inadvertently happen. Alpaca
          does not accept wire transfers from, or issue wire transfers to, third
          parties. As such, the name and address on the account of both the
          initiator and recipient of wire transfers coming to or being sent from
          Alpaca must be the same.
        </span>
      }
    />
  );
};
